import '../style.css'
import Button from '../../atoms/Buttons'
import { useFormContext } from 'react-hook-form'

export const PreviewPartnerBanner = ({ imageUrl, videoUrl, index }) => {
  const methods = useFormContext()

  const handleRedirect = url => {
    const formattedUrl = url?.startsWith('http') ? url : `http://${url}`
    window.open(formattedUrl, '_blank')
  }

  return (
    <div className="h-[212.131px] sm:h-[422px] lg:h-[701px] w-full relative">
      {imageUrl ? (
        <img
          src={imageUrl}
          alt="bg_image"
          className={`h-[212.131px] sm:h-[422px] lg:h-[701px] w-full object-cover ${
            index === 1 && 'rounded-[24px]'
          }`}
        />
      ) : (
        <video
          className={`w-full h-[212.131px] sm:h-[422px] lg:h-[701px] object-cover ${
            index === 1 && 'rounded-[24px]'
          }`}
          src={videoUrl}
          autoPlay
          loop
          muted
        />
      )}

      <div className="absolute top-[50%] space-y-[.5rem]  text-center left-[50%] transform -translate-x-1/2 -translate-y-1/2">
        <h1
          id="title"
          className="text-[24px] sm:text-[38px] md:text-[46px] lg:text-[64px]"
        >
          {methods?.watch('title')}
        </h1>
        <p className="preview_description text-[10px] sm:text-[14px] leading-[12px] sm:leading-[24px]">
          {methods?.watch('description')}
        </p>
        {methods?.watch('button_text') && index !== 1 && (
          <Button
            onClick={() => handleRedirect(methods?.watch('url'))}
            className="preview_btn mx-auto cursor-pointer"
          >
            {methods?.watch('button_text')}
          </Button>
        )}

        {methods?.watch('button_text') && index === 1 && (
          <Button
            onClick={() => handleRedirect(methods?.watch('url'))}
            className="!text-[14px] leading-[24px] text-[#2B364B] !bg-white border-none mx-auto cursor-pointer font-medium font-[montserrat] mt-[24px] rounded-[56px] !w-[128px] !h-[40px]"
            primary
          >
            {methods?.watch('button_text')}
          </Button>
        )}
      </div>
    </div>
  )
}
